import React from "react";

import Confirmation from "@/components/Confirmation";
import DropDownSelect from "@/components/DropDownSelect";
import StartEndTimePicker from "@/components/StartEndTimePicker";

import {
  IDoctorConsultationSelection,
  IDoctorConsultationType,
  IDropDownSelectionType,
} from "@/models/doctor";

import { typeOfConsultation } from "@/utils/common";
import { slotReserveFromList } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  availabilitySettings,
  setIsDeleteAvailability,
} from "@/store/slices/doctor/availabilitySettings";

interface IProps {
  startEndTimeSelectionOpen: boolean;
  slotReserveFromOpen: boolean;
  consultationTypeOrClinicSelectionOpen: {
    consultationType: boolean;
    clinicName: boolean;
  };
  closeAvailabilitySelectionModal: () => void;
  selectTypeOfConsultationHandler: (value: string) => void;
  deleteAvailabilitySetting: () => void;
  formData: any;
  saveClinicNameHandler: (value: string) => void;
  saveSlotReserveFromHandler: (value: string) => void;
  closeSlotReserveFromHandler: () => void;
  startEndSaveTimeHandler: (startTime: string, endTime: string) => void;
  closeStartEndTimePickerHandler: () => void;
}

const CreateEditAvailabilityOverlays = (props: IProps) => {
  const {
    consultationTypeOrClinicSelectionOpen,
    closeAvailabilitySelectionModal,
    selectTypeOfConsultationHandler,
    deleteAvailabilitySetting,
    formData,
    saveClinicNameHandler,
    slotReserveFromOpen,
    saveSlotReserveFromHandler,
    closeSlotReserveFromHandler,
    startEndTimeSelectionOpen,
    startEndSaveTimeHandler,
    closeStartEndTimePickerHandler,
  } = props;
  const dispatch = useAppDispatch();
  const {
    clinicList,
    isDeleteAvailability,
    selectedAvailabilitySettingDetail,
  } = useAppSelector(availabilitySettings);

  const confirmDeleteOpenCloseHandler = () =>
    dispatch(setIsDeleteAvailability(!isDeleteAvailability));

  return (
    <>
      {isDeleteAvailability && (
        <Confirmation
          isOpen={isDeleteAvailability}
          closeHandler={confirmDeleteOpenCloseHandler}
          title="delete_availability"
          alterMessage={"confirm_delete"}
          name={
            selectedAvailabilitySettingDetail?.type_of_consultation ===
            IDoctorConsultationType.IN_CLINIC
              ? selectedAvailabilitySettingDetail?.clinic_name ?? ""
              : IDoctorConsultationSelection.VIDEO_CONSULTATION
          }
          actionHandler={deleteAvailabilitySetting}
        />
      )}
      {consultationTypeOrClinicSelectionOpen.consultationType && (
        <DropDownSelect
          type={IDropDownSelectionType.CONSULTATION}
          isOpen={consultationTypeOrClinicSelectionOpen.consultationType}
          closeHandler={closeAvailabilitySelectionModal}
          title="typeOfConsultation"
          values={typeOfConsultation}
          selectedValue={formData?.consultationType ?? ""}
          saveSelectedValues={selectTypeOfConsultationHandler}
        />
      )}
      {consultationTypeOrClinicSelectionOpen.clinicName && (
        <DropDownSelect
          type={IDropDownSelectionType.CLINIC_NAME}
          isOpen={consultationTypeOrClinicSelectionOpen.clinicName}
          closeHandler={closeAvailabilitySelectionModal}
          title="clinic_name"
          values={clinicList}
          selectedValue={formData?.clinicId ?? ""}
          saveSelectedValues={saveClinicNameHandler}
        />
      )}
      {slotReserveFromOpen && (
        <DropDownSelect
          type={IDropDownSelectionType.SLOT_RESERVE_FROM}
          isOpen={slotReserveFromOpen}
          closeHandler={closeSlotReserveFromHandler}
          title="slot_reserve_from"
          values={slotReserveFromList}
          selectedValue={formData?.slotReserveFrom ?? ""}
          saveSelectedValues={saveSlotReserveFromHandler}
        />
      )}
      {startEndTimeSelectionOpen && (
        <StartEndTimePicker
          handleSaveTime={startEndSaveTimeHandler}
          closeStartEndTimePickerHandler={closeStartEndTimePickerHandler}
        />
      )}
    </>
  );
};

export default CreateEditAvailabilityOverlays;
